import Utils from 'core-helpers/utils.js';

const FaqModule = (function (root, doc, undefined) {
    'use strict';

    // Private vars
    const filename = 'faq-module.js';
    const faqWrapperClass = 'js-faq-module';
    const faqItemClass = 'js-faq-module-item-clickable';
    const faqWrapperActiveClass = 'faq-module__item--active';
    let faqWrapper = null;
    let faqItems = null;

    const toggleActiveClass = function(e) {

        if (e) {
            e.preventDefault();
        }

        const hasActiveClass = Utils.hasClass(this, faqWrapperActiveClass);

        // Remove classes from all items
        faqItems.forEach((item) => {
            Utils.removeClass(item, faqWrapperActiveClass);
        });

        // If class wasn't present, add it on given item
        if (!hasActiveClass) {
            Utils.addClass(this, faqWrapperActiveClass);
        }
    };

    const init = () => {
        faqWrapper = Utils.getById(faqWrapperClass);

        // Only proceed if parent is found
        if (!faqWrapper) {
            return false;
        }

        faqItems = Utils.getElementsByClass(faqItemClass, faqWrapper);
        faqItems.forEach((item) => {
            item.addEventListener('click', toggleActiveClass);
        });
    };

    root.addEventListener('load', init);

})(window, document);
